<script>
  import { formatNumber, diffedJson } from "@/utils";
  import FindCustomer from "./_findCustomer.svelte";
  import { asteroid, Subscriber, observable } from "@/meteor.js";
  import Modal from "@/components/Modal.svelte";
  import { Order } from "./orderModel.js";
  import { currentOrder as currentOrderStore } from "@/stores";
  export let route, url, statusOptions, currentOrder;

  const { id } = route.params;
  const order = observable("orders", id);
  $: customer = observable("customers", $order.customerId);
  let form = false;

  $: changes = form && $order && diffedJson(form, $order);
  $: $order && $order._id && setForm();

  function setForm() {
    setTimeout(() => {
      form = new Order($order);
    });
  }

  function handleSave() {
    asteroid.call("orders.update", id, form);
  }

  function selectOrder() {
    currentOrderStore.selectId(id);
  }

  function subtractFromStock(item) {
    return item.priceQuantities.filter(pq => pq.qty && pq.subtractFromStock)
      .length;
  }

  function toggleSubtract(item) {
    const subtract = subtractFromStock(item);
    item.priceQuantities.map(pq => (pq.subtractFromStock = !subtract));
    form = form;
  }

  function correctName() {
    form.customerName = $customer.name;
  }
</script>

{#if form}
  <Modal bgClick={url('orders/index')}>
    <main
      class="relative bg-white p-2 pt-6 sm:p-10 shadow-xl sm:rounded w-full
      sm:w-3/4 md:w-2/3 my-8 mx-auto">
      {#if form.customerId}
        <div class="mb-4">
          Kunde:
          <a href={url('/customers/:id', { id: form.customerId })}>
            {form.customerName || '[unavngivet]'}
          </a>
          {#if form.customerName !== $customer.name}
            <button on:click={correctName} class="ml-3 sm btn outline green">
              Ret til {$customer.name}
            </button>
          {/if}
          <button />
        </div>
      {:else}
        <FindCustomer bind:form />
      {/if}
      <div>
        Status:
        <select bind:value={form.status}>
          {#each statusOptions as option}
            <option value={option.value}>{option.name}</option>
          {/each}
        </select>
      </div>

      <table class="table-auto w-full">
        <thead>
          <tr class="text-right">
            <th class="text-left">Produkt</th>
            <th>Stk pris</th>
            <th>Antal</th>
            <th>Pris</th>
            <th>lokalt lager</th>
          </tr>
        </thead>
        <tbody>
          {#each form.items as item, itemIndex}
            <tr class="font-semibold">
              <td colspan="2">
                <a href={url('/products/:id', { id: item.product })}>
                  {item.productName}
                </a>
              </td>

              <td class="text-right">
                {item.priceQuantities.reduce((qty, price) => qty + (price.qty || 0), 0)}
              </td>
              <td class="text-right">
                {formatNumber(item.totalPriceWithPct, 2)}
              </td>
              <td class="text-right">
                <input
                  type="checkbox"
                  checked={subtractFromStock(item)}
                  on:change={() => toggleSubtract(item)} />
              </td>

            </tr>
            {#each item.priceQuantities.filter(pq => pq.qty) as price, priceIndex}
              <tr class="text-right text-gray-600 text-sm hover:bg-gray-100">
                <td class="text-left border-l pl-2">
                  <a href={url('/products/:id', { id: item.product })}>
                    {item.productName} ({price.PriceQuantity})
                  </a>
                </td>
                <td>{formatNumber(price.Price, 2)}</td>
                <td>{formatNumber(price.qty)}</td>
                <td>{formatNumber(price.totalPrice, 2)}</td>
                <td>
                  <input
                    type="checkbox"
                    bind:checked={price.subtractFromStock} />
                </td>
              </tr>
            {/each}
          {/each}
          <tr>
            <td colspan="4" class="text-right font-bold">
              {formatNumber(form.totalPrice || 0, 2)}
            </td>
          </tr>
        </tbody>
      </table>
      <div class="mt-8 text-right">
        {#if currentOrder._id !== form._id}
          <button class="btn outline gray" on:click={selectOrder}>
            Vælg som aktiv ordre
          </button>
        {/if}
        {#if Object.entries(changes).length}
          <button class="btn solid green" on:click={handleSave}>Gem</button>
        {/if}
      </div>

    </main>
  </Modal>
{/if}
